webpackJsonp([270174675798707],{

/***/ 1124:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(8);
	
	var _static = __webpack_require__(266);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PrivacyPolicyPage = function (_React$PureComponent) {
		_inherits(PrivacyPolicyPage, _React$PureComponent);
	
		function PrivacyPolicyPage() {
			_classCallCheck(this, PrivacyPolicyPage);
	
			return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
		}
	
		PrivacyPolicyPage.prototype.render = function render() {
			var _props$data$page$edge = this.props.data.page.edges[0].node,
			    heading = _props$data$page$edge.heading,
			    body = _props$data$page$edge.body;
	
	
			return _react2.default.createElement(
				'div',
				{ className: _static.wrapperStyle },
				_react2.default.createElement(
					_reactHelmet.Helmet,
					{ title: heading },
					_react2.default.createElement('meta', { property: 'og:type', content: 'website' }),
					_react2.default.createElement('meta', { property: 'og:title', content: heading }),
					_react2.default.createElement('meta', { name: 'description', content: 'InsideOut Institute Privacy Policy Page' }),
					_react2.default.createElement('meta', { property: 'og:description', content: 'InsideOut Institute Privacy Policy Page' })
				),
				_react2.default.createElement(
					'section',
					{ className: _static.innerWrapperStyle },
					_react2.default.createElement(
						'div',
						{ className: _static.introTextStyle },
						_react2.default.createElement(
							'h1',
							{ className: _static.titleStyle },
							heading
						),
						_react2.default.createElement('div', { className: _static.bodyStyle, dangerouslySetInnerHTML: { __html: body } })
					)
				)
			);
		};
	
		return PrivacyPolicyPage;
	}(_react2.default.PureComponent);
	
	PrivacyPolicyPage.propTypes = {
		data: _propTypes2.default.shape({
			page: _propTypes2.default.shape({
				edges: _propTypes2.default.arrayOf(_propTypes2.default.shape({
					node: _propTypes2.default.shape({
						heading: _propTypes2.default.string.isRequired,
						body: _propTypes2.default.string.isRequired
					}).isRequired
				})).isRequired
			}).isRequired
		}).isRequired
	};
	exports.default = PrivacyPolicyPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-privacy-policy-index-js-ae875a906f7051f7bea7.js